import { ChamberMemberProPaymentScheduleEnum } from "../../../graphql/types";

export type ResolveCreateMemberPaymentMethodInput<PaymentMethod extends string> = {
  enabledPaymentMethods: ReadonlyArray<PaymentMethod>;
  paymentSchedule: ChamberMemberProPaymentScheduleEnum | "";
  storedPaymentMethod: PaymentMethod | "";
};

export const getHasPayableMemberFacingReceivable = ({
  addOnInvoiceTotal,
  onboardingFee,
}: {
  addOnInvoiceTotal: number;
  onboardingFee: number;
}) => onboardingFee > 0 || addOnInvoiceTotal > 0;

/**
 * Monthly member-paid applications must use hosted card collection. This is
 * re-derived even when a restarted/prefilled application carries a hidden
 * manual method from its prior annual schedule.
 */
export const resolveCreateMemberPaymentMethod = <PaymentMethod extends string>({
  enabledPaymentMethods,
  paymentSchedule,
  storedPaymentMethod,
}: ResolveCreateMemberPaymentMethodInput<PaymentMethod>): PaymentMethod | "" => {
  const creditCardPaymentMethod = enabledPaymentMethods.find(
    (paymentMethod) => paymentMethod === "creditCard"
  );

  if (paymentSchedule === ChamberMemberProPaymentScheduleEnum.Monthly) {
    return creditCardPaymentMethod || "";
  }

  if (
    storedPaymentMethod &&
    enabledPaymentMethods.includes(storedPaymentMethod)
  ) {
    return storedPaymentMethod;
  }

  return (
    enabledPaymentMethods.find((paymentMethod) => paymentMethod !== "free") ||
    ""
  );
};
